import { EmailPreview } from '@sequencehq/core-components'

import { getLogoSrc } from 'Customer/utils/logo'
import { AgentReviewedEmail } from './types'

/**
 * The forwarded source email rendered as a collapsible `EmailPreview`, shown in
 * an agent-review task's preview timeline. Starts collapsed; layout (margins) is
 * owned by the parent. Shared by the customer-info and invoice-update reviews.
 */
export const SourceEmailPreview = ({
  source,
  'data-testid': dataTestId
}: {
  source: AgentReviewedEmail
  'data-testid'?: string
}) => {
  // Resolve the sender's company logo from their email domain (logo.dev),
  // reusing the same helper that resolves the customer logo in the header.
  const domain = source.fromEmail.split('@').at(1)
  const logoUrl = domain ? getLogoSrc({ domain }) : undefined

  return (
    <EmailPreview
      // The forwarded email's source only carries the sender address, so it
      // stands in for both the display name and the email in the From header.
      from={{ name: source.fromEmail, email: source.fromEmail, logoUrl }}
      to={[]}
      subject={source.subject}
      // The excerpt is plain text (e.g. a forwarded message with header lines);
      // preserve its line breaks rather than collapsing them as HTML would.
      body={source.excerpt}
      plainTextBody
      startCollapsed
      width="100%"
      data-testid={dataTestId}
    />
  )
}
